// SPDX-License-Identifier: AGPL-3.0-or-later

import ChannelBumps from '@app/features/bump/state/ChannelBumps';
import type {GatewayHandlerContext} from '@app/features/gateway/events/EventRouter';
import ReadStates from '@app/features/read_state/state/ReadStates';
import Notification from '@app/features/ui/state/Notification';

export interface MessageAckPayload {
	channel_id: string;
	message_id: string;
	mention_count: number;
	manual?: boolean;
	version?: string;
}

export function handleMessageAck(data: MessageAckPayload, _context: GatewayHandlerContext): void {
	ReadStates.handleMessageAck({
		channelId: data.channel_id,
		messageId: data.message_id,
		mentionCount: data.mention_count,
		manual: data.manual ?? false,
		version: data.version,
	});
	Notification.handleMessageAck({channelId: data.channel_id});
	// LOCAL-ONLY (bump-plan.md section 3): a manual ack this client didn't send may be a bump; fetch the records.
	ChannelBumps.handleMessageAck(data.channel_id, data.manual ?? false);
}
